import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NewsletterService } from '../../shared/services/newsletter.service';
import { GenericEventService, PohService } from 'src/app/shared/services';
import { Subscription } from 'rxjs';
import { BuilderPage, PageComponents, PageInfo } from 'src/app/core/interfaces';
import { PageLayout } from '../layout.enum';
import { EventTypeEnumerate } from 'src/app/core/enumerates';
import { RouterOutlet } from '@angular/router';
import { AppFooterComponent } from '../../shared/components/footer/footer.component';
import { AppBreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { AppHeaderComponent } from '../../shared/components/header/header.component';
import { AppAdvantagesBannerComponent } from '../../shared/components/builder/advantages-banner/advantages-banner.component';
import { AppGlobalAnnouncementBannerComponent } from '../../shared/components/builder/global-announcement-banner/global-announcement-banner.component';
import { NgClass } from '@angular/common';
import { AppTimerBaseComponent } from '../../shared/components/builder/timer/timer-base/timer.component';

@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  standalone: true,
  imports: [
    NgClass,
    AppGlobalAnnouncementBannerComponent,
    AppAdvantagesBannerComponent,
    AppHeaderComponent,
    AppBreadcrumbComponent,
    RouterOutlet,
    AppFooterComponent,
    AppTimerBaseComponent,
  ],
})
export class AppDefaultLayoutComponent implements OnInit, OnDestroy, OnChanges {
  private genericEventService = inject(GenericEventService);

  isPohPage: boolean = false;
  isAPohPdp: boolean = false;
  isMobileOpen: boolean = false;
  pohServiceSubscription: Subscription | undefined;
  pohPdpServiceSubscription: Subscription | undefined;
  genericEventServiceSubscription: Subscription | undefined;
  // default page info
  page: BuilderPage = {
    pageProvider: 'builder.io',
    name: '',
    type: '',
    pageType: PageLayout.Default,
    extraData: {
      title: '',
      id: '',
      path: '',
      components: new PageComponents(),
    },
  };

  @Input() pageData: any;

  constructor(
    private newsLetterService: NewsletterService,
    private pohService: PohService,
  ) {}

  ngOnInit(): void {
    this.newsLetterService.setShowNewsletter(this.page.extraData?.components?.newsletter ?? true);

    this.pohServiceSubscription = this.pohService.isAPohPage(true).subscribe((isPohPage) => {
      this.isPohPage = isPohPage;
    });

    this.pohPdpServiceSubscription = this.pohService.isAPohProductPage().subscribe((res) => (this.isAPohPdp = res));

    this.genericEventServiceSubscription = this.genericEventService.subscribe(EventTypeEnumerate.APP_MENU_CLICK, (event: any) => {
      this.isMobileOpen = event.status;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pageData?.currentValue) {
      this.checkAndProcessPageData(changes.pageData?.currentValue);
    }
  }

  ngOnDestroy() {
    this.pohServiceSubscription?.unsubscribe();
    this.pohPdpServiceSubscription?.unsubscribe();
    this.genericEventServiceSubscription?.unsubscribe();
  }

  mobileOpenEvent(event: boolean): void {
    this.isMobileOpen = event;
  }

  private checkAndProcessPageData(page: PageInfo<BuilderPage>): void {
    if (page.data) {
      this.page = page.data;
      this.newsLetterService.setShowNewsletter(this.page.extraData?.components?.newsletter ?? true);
    }
  }
}
